import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(VDataTable, {
                staticClass: "table-inca-detail mb-0",
                attrs: {
                  id: "table_details",
                  items: _vm.items,
                  headers: _vm.fields,
                  responsive: "",
                  hover: "",
                  small: true,
                  "sticky-header": true,
                  "show-empty": "",
                  "tbody-tr-class": _vm.rowClass,
                  "hide-default-footer": "",
                  stacked: "sm",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function (ref) {
                      var item = ref.item
                      var index = ref.index
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { right: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var attrs = ref.attrs
                                    var on = ref.on
                                    return [
                                      item.active
                                        ? _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "mr-2 btn-icon-inca",
                                                  attrs: {
                                                    size: "sm",
                                                    icon: "",
                                                    small: "",
                                                    variant: "outline-danger",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onClickActivate(
                                                        item,
                                                        false
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v("mdi-toggle-switch"),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("my_tasks.deactivate"))),
                            ]),
                          ]
                        ),
                        _c(
                          VTooltip,
                          {
                            attrs: { right: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var attrs = ref.attrs
                                    var on = ref.on
                                    return [
                                      !item.active
                                        ? _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "mr-2 btn-icon-inca",
                                                  attrs: {
                                                    size: "sm",
                                                    small: "",
                                                    icon: "",
                                                    variant: "outline-primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onClickActivate(
                                                        item,
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v(
                                                  "mdi-toggle-switch-off-outline"
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("my_tasks.activate"))),
                            ]),
                          ]
                        ),
                        _c(
                          VTooltip,
                          {
                            attrs: { right: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var attrs = ref.attrs
                                    var on = ref.on
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-2 btn-icon-inca",
                                              attrs: {
                                                id:
                                                  "popover-button-sync-" +
                                                  _vm.record.id +
                                                  index,
                                                size: "sm",
                                                icon: "",
                                                small: "",
                                                variant: "outline-secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onClickDelete(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-delete")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("my_tasks.delete"))),
                            ]),
                          ]
                        ),
                        _c(
                          "b-popover",
                          {
                            ref: "popover",
                            attrs: {
                              target:
                                "popover-button-sync-" + _vm.record.id + index,
                              title: "¿Confirm to delete?",
                            },
                          },
                          [
                            _c(
                              "b-container",
                              { attrs: { fluid: "" } },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-secondary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDeleteClose(index)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.cancel"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-danger",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDeleteAccept(
                                                  item,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.accept"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }